import { createI18n } from 'vue-i18n'

import enUS from './en-US.json'

export const i18n = createI18n({
  messages: {
    'en-US': enUS,
  },
})
